import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if (document.body.matches('#videos')) {
    function handleLegacyAccess() {
      // Redirect if this view is accessed through a URL like /videos#video__video-id
      // which is the previous way of focusing on the current video, e.g accessing
      // /videos#__video_id should redirect to /videos/category/video_id.
      const { hash } = window.location;
      if (hash) {
        const videoId = hash.split('__').at(-1);

        fetch(`/api/videos/${videoId}`)
          .then((response) => response.json())
          .then((data) => {
            window.location.href = `/videos/${data.video_category_slug}/${videoId}`;
          })
          .catch((error) => console.error(error));
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      handleLegacyAccess();
    });
  }
});
